import { Descriptions, DescriptionsProps } from "antd";
import moment from "moment";
import getElapsedTime from "./getElapsedTime";

interface IDuplicateDataObjectJobMetaDataProps {
    job: IDataObjectsDuplicateJob;
    show?: boolean;
}

export default function DuplicateDataObjectJobMetaData({ job, show }: IDuplicateDataObjectJobMetaDataProps) {
    const jobMetaData: DescriptionsProps["items"] = [
        {
            key: "1",
            label: "Config",
            span: 3,
            children: `${job.name} (${job.jobId})`,
        },
        {
            key: "2",
            label: "User",
            children: job.createdByEmail,
        },
        {
            key: "3",
            label: "Started Date",
            children: moment.utc(job.startedDate).toDate().toLocaleDateString(),
        },
        {
            key: "4",
            label: "Started Time",
            children: moment.utc(job.startedDate).toDate().toLocaleTimeString(),
        },
        {
            key: "5",
            label: "Completed Date",
            children: moment.utc(job.completedDate).toDate().toLocaleDateString(),
        },
        {
            key: "6",
            label: "Completed Time",
            children: moment.utc(job.completedDate).toDate().toLocaleTimeString(),
        },
        {
            key: "7",
            label: "Elapsed Time",
            children: getElapsedTime(job),
        },
        {
            key: "8",
            label: "Tags",
            children: job.jobInfo.dataTags.join(", "),
        },
        {
            key: "9",
            label: "Total Records",
            children: job.runInfo?.totalRecords,
        },
        {
            key: "10",
            label: "Total Clusters",
            children: job.runInfo?.totalClusters,
        },
    ];

    return <Descriptions items={jobMetaData} layout="horizontal" size="small" bordered style={{ display: show ? "block" : "none" }} />;
}
